export default __webpack_public_path__ + "static/media/LogicoLogo.4463b7f0.svg";